import React from 'react';
import MockupShell from './MockupShell';

const PERSONAL = [
  { name: 'Sarah K.',  city: 'Portland, OR', joined: '14m ago', expires: '46 min', risk: 'normal' },
  { name: 'Devon M.',  city: 'Tampa, FL',    joined: '23m ago', expires: '37 min', risk: 'normal' },
  { name: 'Priya N.',  city: 'Denver, CO',   joined: '41m ago', expires: '19 min', risk: 'soon' },
  { name: 'James R.',  city: 'Houston, TX',  joined: '57m ago', expires: '3 min',  risk: 'urgent' },
];

const NETWORK = [
  { name: 'Maria G.',  city: 'Albuquerque, NM', from: 'Released by Justin H.', expires: '11 min' },
  { name: 'Tyrese B.', city: 'Atlanta, GA',     from: 'Released by Mia L.',     expires: '38 min' },
];

function badgeForRisk(risk) {
  if (risk === 'urgent') return <span className="mk-badge mk-badge--red">Expires soon</span>;
  if (risk === 'soon')   return <span className="mk-badge mk-badge--amber">Expires in &lt; 30m</span>;
  return <span className="mk-badge mk-badge--success">Active</span>;
}

export default function PersonalPifQueue() {
  return (
    <MockupShell
      title="Personal Pay-It-Forward Queue"
      subtitle="Prospects assigned to you first. Claim them before they release to your Network and Global queues."
      dataTestId="mockup-personal-pif"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>How your Personal queue works.</strong> Every prospect who signs up using your
        referral link sits here for <strong>60 minutes</strong>. You pay forward 5.95 USDT (TRC-20)
        via NowPayments and they become your direct downline. After 60 minutes, they release to
        your Network. After another 60, they hit the Global PIF List.
      </div>

      <div className="mk-grid mk-grid--3" style={{ marginBottom: 18 }}>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">In personal queue</span><span className="mk-stat-value">4</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Claimed today</span><span className="mk-stat-value">3</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Released this week</span><span className="mk-stat-value">2</span></div></div>
      </div>

      <h3 style={{ margin: '8px 0 12px' }}>Your personal queue</h3>
      <div className="mk-card" style={{ padding: 0 }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {PERSONAL.map((p, i) => (
            <li key={p.name} style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto auto', gap: 14, alignItems: 'center', padding: '14px 18px', borderBottom: i < PERSONAL.length - 1 ? '1px solid var(--mk-border)' : 'none' }}>
              <span style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg, #ffd968, #d99410)', color: '#0b0f15', display: 'grid', placeItems: 'center', fontWeight: 800, fontSize: 15 }}>{p.name[0]}</span>
              <div>
                <strong style={{ fontSize: 14 }}>{p.name}</strong>
                <div style={{ fontSize: 12, color: 'var(--mk-muted)' }}>{p.city} · Joined {p.joined} · Expires in {p.expires}</div>
              </div>
              {badgeForRisk(p.risk)}
              <button className="mk-btn" data-testid={`personal-pif-pay-btn-${i}`}>Pay 5.95 USDT</button>
            </li>
          ))}
        </ul>
      </div>

      <h3 style={{ margin: '24px 0 12px' }}>Your network queue</h3>
      <p style={{ fontSize: 12, color: 'var(--mk-muted)', margin: '0 0 10px' }}>
        Prospects released to you by upline members in your network. Same Pay-It-Forward rules apply.
      </p>
      <div className="mk-card" style={{ padding: 0 }}>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {NETWORK.map((p, i) => (
            <li key={p.name} style={{ display: 'grid', gridTemplateColumns: 'auto 1fr auto auto', gap: 14, alignItems: 'center', padding: '14px 18px', borderBottom: i < NETWORK.length - 1 ? '1px solid var(--mk-border)' : 'none' }}>
              <span style={{ width: 38, height: 38, borderRadius: '50%', background: '#2a3344', color: 'var(--mk-text)', display: 'grid', placeItems: 'center', fontWeight: 800, fontSize: 15 }}>{p.name[0]}</span>
              <div>
                <strong style={{ fontSize: 14 }}>{p.name}</strong>
                <div style={{ fontSize: 12, color: 'var(--mk-muted)' }}>{p.city} · {p.from} · Expires in {p.expires}</div>
              </div>
              <span className="mk-badge mk-badge--gold">NETWORK</span>
              <button className="mk-btn mk-btn--gold-outline">Pay 5.95 USDT</button>
            </li>
          ))}
        </ul>
      </div>
    </MockupShell>
  );
}
